import { motion } from "framer-motion";

const facts = ["Attleboro, MA", "Dean College", "Business Management", "Men's Soccer"];

export default function Manifesto() {
  return (
    <section className="grain relative bg-navy px-5 py-20 sm:px-10 lg:py-32 xl:px-16" data-testid="manifesto-section">
      <p className="mb-3 font-mono2 text-[11px] uppercase tracking-[0.35em] text-royal">Meet the owner</p>
      <h2 className="mb-14 font-display text-5xl uppercase leading-none text-white sm:text-7xl">Why Gone Today</h2>
      <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12">
        <motion.figure
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <div className="overflow-hidden border border-white/25">
            <img
              src="/jobs/clay-soccer.jpg"
              alt="Clay Tyler playing for the Dean College men's soccer team"
              loading="lazy"
              data-testid="manifesto-photo"
              className="block h-auto w-full"
            />
          </div>
          <figcaption className="flex items-center justify-between border border-t-0 border-white/25 px-5 py-4">
            <span className="font-display text-lg uppercase text-white">Clay Tyler, #6</span>
            <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-white/50">Dean College Soccer</span>
          </figcaption>
        </motion.figure>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <div className="mb-6 flex flex-wrap gap-2" data-testid="manifesto-facts">
            {facts.map((f) => (
              <span key={f} className="border border-white/25 px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-white/70">
                {f}
              </span>
            ))}
          </div>
          <div className="space-y-5 text-base leading-relaxed text-white/80 md:text-lg" data-testid="manifesto-bio">
            <p>
              My name is Clay Tyler, and I'm from Attleboro, Massachusetts. I'm currently a student at
              Dean College studying Business Management and I'm also a member of the Men's Soccer team.
            </p>
            <p>
              I started Gone Today Junk Removal because I wanted to build something of my own while
              gaining real experience running a business. I enjoy working hard, meeting new people,
              and helping customers clear out unwanted junk without the stress of doing it themselves.
            </p>
            <p>
              My goal is to keep growing Gone Today Junk Removal while I'm in college and use what I
              learn in school to make the business better. I take pride in being reliable, working hard,
              and making sure every customer is happy with the job.
            </p>
          </div>
          <p className="mt-8 border-l-4 border-royal pl-5 font-display text-2xl uppercase leading-tight text-white sm:text-3xl">
            "Reliable, hard-working, and every customer happy with the job."
          </p>
        </motion.div>
      </div>
    </section>
  );
}
